import React, { Component } from 'react';
import Comment from '../../../../../common/comments/comment.component';
import { Loading } from '../../../../../common/loading';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { billingAccountActions } from '../../../../../../store/external/finance/billing-account.reducer';

class BillingComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }

    }

    componentDidMount() {
        const { getBillingComments, billingAccount } = this.props;
        getBillingComments(this.props.financeAccountID, 1)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postBillingComments } = this.props;
        await postBillingComments(this.props.financeAccountID, attachedFilename, attachedFileData, commentDescription);
     }

    handleDeleteBillingComments = async (financeAccountID) => {
        this.setState({ isLoading: true });
        const { deleteBillingComments, getBillingComments, billingAccount, clearBillingAccountComments } = this.props;
        await deleteBillingComments(financeAccountID);
        clearBillingAccountComments();
        await getBillingComments(this.props.financeAccountID, 1, billingAccount?.billingComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () => {
        const { getBillingComments, billingAccount} = this.props;
        await getBillingComments(this.props.financeAccountID, billingAccount.pageIndex + 1)
    }

    componentWillUnmount() {
        this.props.clearBillingAccountComments();
    }


    render() {
        const { billingComments, hasMoreComments } = this.props.billingAccount;
        if (this.state.isLoading) {
            return <Loading />
        }

        return (
            <div>
                <Comment
                    commentList={billingComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteBillingComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isBillingComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={hasMoreComments}

                    //Access Types
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}                  
                />
            </div>
        );
    }
}

export default connect(
    state => {
        const { billingComments, billingAccount } = state;

        return {
            billingComments, billingAccount
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, billingAccountActions),
        dispatch
    )
)(BillingComment);